import { LoadMode } from "./index49.js";
import { ThreadOptions } from "./index51.js";
function getNextThread(thread, loadMode) {
	const nextThreads = (loadMode === LoadMode.single ? ThreadOptions.singleLoadOptions : loadMode === LoadMode.double ? ThreadOptions.doubleLoadOptions : ThreadOptions.allLoadOptions).map((prop) => ({
		thread: thread.add(prop),
		start: prop.start
	})).filter((t) => t.thread);
	nextThreads.sort((a, b) => b.thread.data.size - a.thread.data.size);
	return nextThreads.at(0);
}
export { getNextThread };

//# sourceMappingURL=index52.js.map